import { StringUtils } from 'casetivity-shared-js/lib/spel/evaluation-context/utils/StringUtils';
export default StringUtils;
